export default {
  category: {
    id: "text-page",
    label: "Text Page",
  },
};
